<template>
  <div>
    <el-dialog
      title="日活用户"
      :visible="dialogVisible"
      width="80%"
      custom-class="dialog"
      @close="handleClose"
      :footer="false"
    >
      <Account />
      
    </el-dialog>
  </div>
</template>
<script>
import Account from './Account'
export default {
  props:['dialogVisible'],
  methods:{
    handleClose(){
      this.$emit('update:dialogVisible',false)
    }
  },
  components:{
    Account
  }
};
</script>
<style lang="scss"> 
.dialog{
  

  .el-dialog__body{
    padding-top:0px !important;
    padding-bottom: 80px !important;
  } 
}
</style>



// WEBPACK FOOTER //
// modal.vue?08da4c12